"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGrid = exports.StyledRow = exports.StyledCol = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  background: ", ";\n  height: ", ";\n  display: block;\n  border-bottom: ", ";\n\n  ", " {\n    background: ", ";\n    border-bottom: ", ";\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  ", " {\n    background: ", ";\n    border-right: ", ";\n\n    &:last-child {\n      border-right: none;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  border-bottom: ", ";\n\n  display: block;\n  width: 100%;\n  height:  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  height: 100%;\n  width: ", ";\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCol = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var width = _ref.width;
  return "".concat(width || 100, "%");
});

exports.StyledCol = StyledCol;

var StyledRow = _styledComponents["default"].div(_templateObject2(), function (_ref2) {
  var last = _ref2.last,
      borderWidth = _ref2.borderWidth;

  if (last) {
    return 'none';
  }

  var width = "".concat(borderWidth || 1, "px");
  return "".concat(width, " solid #F4F4F4");
}, function (_ref3) {
  var height = _ref3.height;
  return "".concat(height || 100, "%");
});

exports.StyledRow = StyledRow;

var StyledGrid = _styledComponents["default"].div(_templateObject3(), function (_ref4) {
  var bgColor = _ref4.gridStyle.bgColor;
  return bgColor || 'white';
}, function (_ref5) {
  var height = _ref5.height;
  return "".concat(height, "px");
}, function (_ref6) {
  var _ref6$gridStyle = _ref6.gridStyle,
      borderWidth = _ref6$gridStyle.borderWidth,
      borderColor = _ref6$gridStyle.borderColor;
  return "".concat(borderWidth || 1, "px solid ").concat(borderColor || "#F4F4F4");
}, StyledRow, function (_ref7) {
  var bgColor = _ref7.gridStyle.bgColor;
  return bgColor || 'white';
}, function (_ref8) {
  var _ref8$gridStyle = _ref8.gridStyle,
      borderWidth = _ref8$gridStyle.borderWidth,
      borderColor = _ref8$gridStyle.borderColor;
  var width = "".concat(borderWidth || 1, "px");
  return "".concat(width, " solid ").concat(borderColor || "#F4F4F4");
}, StyledCol, function (_ref9) {
  var bgColor = _ref9.gridStyle.bgColor;
  return bgColor || 'white';
}, function (_ref10) {
  var _ref10$gridStyle = _ref10.gridStyle,
      borderWidth = _ref10$gridStyle.borderWidth,
      borderColor = _ref10$gridStyle.borderColor;
  var width = "".concat(borderWidth || 1, "px");
  return "".concat(width, " solid ").concat(borderColor || "#F4F4F4");
});

exports.StyledGrid = StyledGrid;

//# sourceMappingURL=styled.js.map